// @mui
import { Box, BoxProps } from "@mui/material";

// ----------------------------------------------------------------------

export default function Logo({ ...other }: BoxProps) {
  const fill = "#333033";
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        // mr: 4,
      }}
      {...other}
    >
      <a
        href="https://www.thrivelab.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 172.67 34.81"
          width="110px"
          height="22px"
        >
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path
                fill={fill}
                d="M10.91,31.14c-1.17,2.49-2.49,3.67-5.41,3.67C1.93,34.81.05,32.5.05,28L0,5.64c1-.09,2.78-.89,4.33-1.08V11h6.35v1.27H4.33v15.9c0,2.68.75,4.33,3,4.33a3.7,3.7,0,0,0,3.24-1.65Z"
              />
              <path
                fill={fill}
                d="M30.91,30V19.33c0-4.19-2-6.59-5.6-6.59A7.07,7.07,0,0,0,19,16.23V30c0,2.3.14,3.62.94,4.47H13.69c.85-.85,1-2.17,1-4.47V8.23c0-2.31-.24-5.46-1.13-6.3C15.05,1.78,17.12.24,18.91,0V14.86a9.81,9.81,0,0,1,8-4.42c5.5,0,8.28,3.2,8.28,9.22V30c0,2.3.14,3.62,1,4.47H30c.8-.85.95-2.17.95-4.47"
              />
              <path
                fill={fill}
                d="M55.5,11.52l-1.18,2.82h0a3.66,3.66,0,0,0-3.52-2.25,6.8,6.8,0,0,0-6.26,4.13V30c0,2.3.14,3.62.94,4.47H39.22c.85-.85,1-2.17,1-4.47V15.57c0-2.26-.19-3.3-1-4.14a39.72,39.72,0,0,0,4.93-.57v4.47c1.51-3,3.91-4.89,7-4.89a8.8,8.8,0,0,1,4.38,1.08"
              />
              <path
                fill={fill}
                d="M64.94,34.48H58.55c.89-.85,1.08-2.17,1.08-4.47V15.47c0-2.3-.24-3.38-1.13-4.23,1.5-.1,3.62-.24,5.41-.47V30c0,2.3.19,3.62,1,4.47"
              />
              <path
                fill={fill}
                d="M64,4.23a2.63,2.63,0,0,1-5.26,0,2.63,2.63,0,0,1,5.26,0"
              />
              <path
                fill={fill}
                d="M90.3,10.86a7,7,0,0,0-2.17,3.67L80.94,34.48h-4L69.69,14.63a7.34,7.34,0,0,0-2.35-3.77h6.21c-.85.94-.09,2.12.47,3.58l6.4,17.68,6.35-17.73c.52-1.46.7-2.78-.24-3.53Z"
              />
              <path
                fill={fill}
                d="M95,21.31l13.32,0c-.19-6-2.26-9.92-6.26-9.92s-6.73,3.9-7.06,9.88m0,1.31c0,7.15,3.52,11,7.76,11a11.18,11.18,0,0,0,7.85-3.95h0l.89,1.88a15.09,15.09,0,0,1-9.45,3.3c-6.68,0-11.71-4.71-11.71-12.09,0-6.92,4.7-12.28,11.61-12.28s10.31,4.94,10.4,11.71v.42H94.91Z"
              />
              <path
                fill={fill}
                d="M115.11,1.92c1.51-.14,3.62-1.68,5.41-1.92V30c0,2.3.19,3.62,1,4.47h-6.4c.89-.85,1.08-2.17,1.08-4.47V6.16c0-2.31-.23-3.39-1.13-4.24"
              />
              <path
                fill={fill}
                d="M140.7,30.2V24.83a7.54,7.54,0,0,0-5.5-2.26c-4.1,0-5.74,2.54-5.74,5.08,0,2.73,2.21,5,5.78,5a7.66,7.66,0,0,0,5.46-2.44m.38,4.28-.24-3.3a9.8,9.8,0,0,1-7.71,3.63c-4.57,0-7.86-2.73-7.86-6.92s3.34-7,8.61-7a10,10,0,0,1,6.82,2.64V19.09c0-4.37-1.32-7.52-6-7.52A9.55,9.55,0,0,0,127.86,15h0l-.7-2.3a14.42,14.42,0,0,1,8.23-2.26c7.15,0,9.59,3.86,9.59,9.41V30.57c0,2,.1,3.11.85,3.91Z"
              />
              <path
                fill={fill}
                d="M168.24,22.72c0-6.78-2.82-10-7.19-10a8,8,0,0,0-6.4,4.1V28.12c1.55,2.83,4.28,4.38,6.4,4.38,4.42,0,7.19-3.25,7.19-9.78m4.43,0c0,7.48-3.77,12.09-9.88,12.09a8.5,8.5,0,0,1-8.14-5.27l-.42,4.94h-4.94c.89-.85,1.08-2.17,1.08-4.47V6.16c0-2.31-.19-3.39-1.08-4.23,1.5-.1,3.62-1.69,5.41-1.93l0,15.66a8.52,8.52,0,0,1,8.14-5.22c5.92,0,9.88,4.66,9.88,12.28"
              />
            </g>
          </g>
        </svg>
      </a>
    </Box>
  );
}
